import Header from "./shared/header";
import Footer from "./shared/footer";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";

import Contact from "./shared/contact";
import DesktopLayout from "./shared/desktop_layout";
import {
  HowWeWorkHero,
  OperatingModel,
  ProjectDelivery,
  HumanAITeams,
  StrategicEngagement,
  SpeedQualityScale
} from "./shared/how-we-work";

function HowWeWork() {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <Layout>
        <Header color="rgba(11, 21, 76, 1)" />
      </Layout>
      <div className="h-[24px] bg-white" />
      
      {/* Hero Section */}
      <Layout backgroundColor="black">
        <HowWeWorkHero />
      </Layout>
      
      {/* Operating Model Section */}
      <Layout>
        <OperatingModel />
      </Layout>
      
      {/* Project Delivery Section */}
      <Layout backgroundColor="black">
        <ProjectDelivery />
      </Layout>
      
      {/* Human + AI Teams Section */}
      <Layout>
        <HumanAITeams />
      </Layout>
      
      {/* Strategic Engagement Section */}
      <Layout backgroundColor="black">
        <StrategicEngagement />
      </Layout>
      
      {/* Speed, Quality, Scale Section */}
      <Layout>
        <SpeedQualityScale />
      </Layout>
      
      {/* Footer */}
      <Layout>
        <Footer />
      </Layout>
    </div>
  );
}

export default HowWeWork; 